import React, { useEffect, useState } from 'react';
import { Box, Container, MenuItem, Tab, Tabs, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { css } from "styled-components";
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { PacmanLoader } from 'react-spinners';
import Avatar from 'react-avatar';
import { useAuth0 } from '@auth0/auth0-react';
import {
  getUser as getCachedUser,
  logoutLocalStorage
} from '../../../src/Auth/Signin/Signin';
import useAuthCache from '../../hooks/useAuthCache';
import ActionsMenu from '../MenuItem';

export const ScrollBarStyle = css`
    ::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 6px;
    }
    ::-webkit-scrollbar {
        width: 7px;
        background-color: transparent;
        height: 7px;
    }
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
        width: 7px;
    }
    ::-webkit-scrollbar-thumb {
        background: #888;
        width: 5px;
        border-radius: 6px;
    }
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
`

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box >
          {children}
        </Box>
      )}
    </div>
  );
}

export default function FnMenu({ listTab, valueInitial, loadingInitial }) {
  const history = useHistory()
  const location = useLocation();
  const [valueHash, setValueHash] = useState(() => (location.hash || "").replace("#", ""));

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("950"));

  const valueDefault = valueHash || valueInitial

  const { isLoading: auth0Loading, user: authCacheUser } = useAuthCache();
  const {
    isLoading,
    logout: auth0Logout,
    user: auth0User,
    isAuthenticated,
  } = useAuth0();

  // Preferir o user do Auth0 (já disponível após loginWithPopup);
  // o cache em localStorage só é gravado no efeito async de useAuthCache.
  const user = auth0User || authCacheUser || getCachedUser();
  const isStillLoading = isLoading || auth0Loading || loadingInitial;
  const showUserMenu = Boolean(user) || (isAuthenticated && isStillLoading);

  const logout = () => {
    logoutLocalStorage();
    auth0Logout({ logoutParams: { returnTo: window.location.origin } });
  }

  useEffect(() => {
    if (!listTab.some((l) => l.value === valueHash)) {
      history.replace({
        pathname: location.pathname,
        search: location.search,
        hash: `#${valueInitial}`,
      });
      setValueHash(valueInitial);
    }
  }, [valueHash, listTab, valueInitial, history, location.pathname, location.search]);

  const handleChange = (_, newValue) => {
    setValueHash(newValue);
    history?.push(`#${newValue}`)
  };

  return (

    <Container style={{ maxWidth: "unset", padding: 0 }}>

      <Box
        style={{
          backgroundColor: "rgb(0 0 0 / 68%)",
          boxShadow: "rgb(0, 0, 0) 0px 15px 50px 1px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          alignContent: "center",
          flexDirection: "row",
        }}
        sx={{ borderColor: 'divider' }}
      >
        {showUserMenu && (
          <Box sx={{ position: 'absolute', right: isStillLoading && !user ? 20 : 10 }}>
            {isStillLoading && !user ? (
              <PacmanLoader color={"#ffc356"} size={7} aria-label="Loading Spinner" data-testid="loader" />
            ) : (
              <ActionsMenu
                button={({ onClick }) =>
                  <Avatar style={{ cursor: "pointer" }} name={user?.name} size="40" round={true} src={user?.picture} onClick={onClick} />
                }
              >
                <MenuItem disabled={true}>
                  <Typography>{user?.name}</Typography>
                </MenuItem>
                <MenuItem disabled={true}>
                  <Typography>{user?.email}</Typography>
                </MenuItem>
                <MenuItem onClick={logout}>
                  <Typography>Fazer logout</Typography>
                </MenuItem>
              </ActionsMenu>
            )}
          </Box>
        )}

        <Tabs
          value={valueDefault}
          onChange={handleChange}
          variant={isMobile ? "fullWidth" : ""}
          aria-label="Menu"
          centered
          textColor="orange"
          sx={{
            ".Mui-selected": {
              color: `orange !important`,
            },
            ".MuiTabs-indicator": {
              backgroundColor: `orange`,
            }
          }}
        >
          {listTab.map((a, i) => (
            <Tab
              style={{ color: "orange" }}
              key={i}
              value={a.value}
              label={a.label}
            />
          ))}

        </Tabs>
      </Box>
      {loadingInitial ?
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            flexDirection: "column",
            gap: "20px"
          }}
        >
          <Typography color="white">Carregando</Typography>
          <PacmanLoader
            color={"#ffc356"}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        </Box>
        :
        <>
          {listTab.map((a, i) => (
            <TabPanel value={valueDefault} index={a.value}>
              {a.pageRedirect}
            </TabPanel>
          ))}
        </>
      }

    </Container>
  )

}
